import _ from "lodash";
import type { DropdownItemProps } from "semantic-ui-react";

/** The keys Semantic UI's DropdownItem understands. `key` and `style` are read by Dropdown itself. */
const DROPDOWN_ITEM_KEYS = [
	"active",
	"as",
	"children",
	"className",
	"content",
	"description",
	"disabled",
	"flag",
	"icon",
	"image",
	"key",
	"label",
	"onClick",
	"selected",
	"style",
	"text",
	"value",
];

/**
 * Strips an option list down to the props Semantic UI's DropdownItem understands.
 *
 * Dropdown spreads every key on an option onto a DOM element, so domain fields carried alongside
 * `key`/`value`/`text` (ex: `analysisId`) trigger React's "does not recognize the prop on a DOM
 * element" warning, and object values render as `[object Object]`. Keep the rich options elsewhere and
 * look them up by `value`.
 */
export const toDropdownItems = (options: readonly DropdownItemProps[] | undefined): DropdownItemProps[] | undefined =>
	options &&
	_.map(options, (option) =>
		_.pickBy(option, (_value, name) => _.includes(DROPDOWN_ITEM_KEYS, name) || _.startsWith(name, "data-")),
	);
